import { render } from "./VnfAppliancesTab.vue?vue&type=template&id=c0982624&scoped=true"
import script from "./VnfAppliancesTab.vue?vue&type=script&lang=js"
export * from "./VnfAppliancesTab.vue?vue&type=script&lang=js"

import "./VnfAppliancesTab.vue?vue&type=style&index=0&id=c0982624&lang=scss&scoped=true"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0982624"]])

export default __exports__